"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleRegistrationNumberValidation = void 0;
var journey_services_1 = require("@athena-portal/journey-services");
var VehicleRegistrationNumberValidation = /** @class */ (function (_super) {
    __extends(VehicleRegistrationNumberValidation, _super);
    function VehicleRegistrationNumberValidation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VehicleRegistrationNumberValidation.prototype.validateInput = function (input, context) {
        var pageContext = context;
        if (pageContext.engine && pageContext.engine.getJourneyState()) {
            var errorCode = pageContext.engine.getJourneyState().ocrErrorCode;
            pageContext.engine.getInteraction().underwritingResult = [];
            if (errorCode) {
                var errorMessage = "Sorry, we couldn't read your registration number. Please upload new photo.";
                switch (errorCode) {
                    case "serviceError":
                        errorMessage = "Failed to upload your photo.";
                        break;
                    case "3":
                        errorMessage = "Sorry, we couldn't read your registration number. Please upload new photo.";
                        break;
                    case "4":
                        errorMessage = "Sorry, we couldn't read your registration number. Please upload photo again.\nIt works best when only your car’s registration number is captured in your photo.";
                        break;
                }
                pageContext.engine.setJourneyState({ ocrErrorCode: null });
                return this.invalidResult(errorMessage);
            }
        }
        return this.validResult();
    };
    return VehicleRegistrationNumberValidation;
}(journey_services_1.ValidationMethodBase));
exports.VehicleRegistrationNumberValidation = VehicleRegistrationNumberValidation;
//# sourceMappingURL=VehicleRegistrationNumberValidation.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/validations/VehicleRegistrationNumberValidation.js
// module id = 2533
// module chunks = 0